import React, { useEffect, useState } from 'react';
import Navbar   from './components/Navbar';
import Hero     from './components/Home';
import Stats    from './components/Stats';
import About    from './components/About';
import Services from './components/Services';
import WhyUs    from './components/WhyUs';
import Contact  from './components/Contact';
import Footer   from './components/Footer';
import { FaChevronUp } from 'react-icons/fa';

const App = () => {
    const [showTop, setShowTop] = useState(false);

    useEffect(() => {
        const onScroll = () => setShowTop(window.scrollY > 400);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <>
            <Navbar />
            <main>
                <Hero />
                <Stats />
                <About />
                <Services />
                <WhyUs />
                <Contact />
            </main>
            <Footer />

            <button
                className={`scroll-top ${showTop ? 'show' : ''}`}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                aria-label="Back to top"
            >
                <FaChevronUp />
            </button>
        </>
    );
};

export default App;
